module.exports = __webpack_public_path__ + "static/media/pluse.9ad662d6.svg";